import React from "react";
import { FLAGS, useFeatureFlag } from "../../../../featureFlags";
import AIActionsDropdown from "./index";

const AIActionsSeam = (props) => (
  <AIActionsDropdown
    {...props}
    opensSummaryPage={useFeatureFlag(FLAGS?.EPICENTER_LEARNING_SUMMARY?.name)}
  />
);

export default AIActionsSeam;
